"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesDrawerSubitemsContainer = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "iconName", type: "string", description: "Name of the icon that will appear in the left side." }),
    React.createElement(common_1.Property, { name: "text", type: "string", description: "Text inside." }),
    React.createElement(common_1.Property, { name: "expanded", type: "bool", defaultValue: "false", description: "If is true, the container will appear expanded." }))); };
exports.PropertiesDrawerSubitemsContainer.displayName = 'PropertiesDrawerSubitemsContainer';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerSubitemsContainerPage/PropertiesDrawerSubitemsContainer.tsx
// module id = 666
// module chunks = 0